import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    MenuItem,
    Select,
    TextField,
    Typography,
    Alert,
    Box
} from '@mui/material';

export default function RofAddProjectDialog({
    handleSubmit,
    open,
    setOpen,
    programmeId,
    setProgrammeId,
    nickname,
    setNickname,
    projectMeasurementType,
    setProjectMeasureType,
    addProjectError,
    setAddProjectError,
}) {
    const measurementUnits = [{ id: 0, type: 'Metric' }, { id: 1, type: 'Imperial' }]
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            PaperProps={{
                sx: { borderRadius: 2, px: 2, py: 1 }
            }}
        >
            <DialogTitle>Add New Project</DialogTitle>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography>Please select Program:</Typography>
                    <FormControl
                        fullWidth
                        variant="outlined"
                    >
                        {/* <InputLabel htmlFor="programme-select"></InputLabel> */}
                        <Select
                            id="programme-select"
                            name="feedstockType"
                            value={programmeId}
                            onChange={e => setProgrammeId(e.target.value)}
                        // label="Program"
                        >
                            <MenuItem value={1}>
                                Place based biochar production, leaving on site
                            </MenuItem>
                            <MenuItem value={2}>
                                Place based biochar production, transport off site for soil use
                            </MenuItem>
                        </Select>
                    </FormControl>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography>Add Project Nickname:</Typography>
                    <TextField
                        inputProps={{
                            sx: {
                                '&::placeholder': {
                                    fontStyle: 'italic'
                                }
                            }
                        }}
                        name='nickname'
                        value={nickname}
                        placeholder='Sample Project'

                        onChange={e => setNickname(e.target.value)}
                    />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography>Select Measurement System:</Typography>
                    <FormControl
                        fullWidth
                        variant="outlined" // Ensure the variant is outlined

                    >
                        {/* <InputLabel sx={{ background: 'white', pl: 1, pr: 1 }}>
                            Unit
                        </InputLabel> */}
                        <Select
                            name='measurementUnits'
                            value={projectMeasurementType}
                            onChange={(e) => setProjectMeasureType(e.target.value)}
                        // disabled={units?.measurementType ? true : false}
                        >
                            {measurementUnits.map(unit => {
                                return (
                                    <MenuItem key={unit.id} value={unit.type}>
                                        {unit.type}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                </Box>
                {addProjectError &&
                    <Box>
                        <Alert severity="error" sx={{ width: 'fit-content' }}>
                            {addProjectError}
                        </Alert>
                    </Box>
                }
                <Box>
                    {projectMeasurementType === 'Imperial'
                        ? <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant='caption'>
                                Please ensure that when data is submitted for this project, it is provided in the following units at the respective form questions:
                            </Typography>
                            <Box component='ul'>
                                <Typography component='li' variant='caption' >
                                    For Feedstock: Cubic yards, acres, tonnes
                                </Typography>
                                <Typography component='li' variant='caption' >
                                    For Kiln or other dimensions: Foot (ft)
                                </Typography>
                                <Typography component='li' variant='caption' >
                                    For Field measurements: Gallons (gal), inches (in) and pounds (lbs)
                                </Typography>
                            </Box>
                        </Box>
                        : projectMeasurementType === 'Metric'
                            ? <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography variant='caption'>
                                    Please ensure that when data is submitted for this project, it is provided in the following units at the respective form questions:
                                </Typography>
                                <Box component='ul'>
                                    <Typography component='li' variant='caption' >
                                        For Feedstock: Cubic meters, hectares, tonnes
                                    </Typography>
                                    <Typography component='li' variant='caption' >
                                        For Kiln or other dimensions: Meters (m)
                                    </Typography>
                                    <Typography component='li' variant='caption' >
                                        For Field measurements: Liters (L), Centimeters (cm) and Kilogram (kg)
                                    </Typography>
                                </Box>
                            </Box> : null
                    }
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={() => {
                    setOpen(false)
                    setProgrammeId(null);
                    setNickname('');
                }}>
                    Cancel
                </Button>
                <Button variant='contained' onClick={() => {
                    if (programmeId && nickname && projectMeasurementType) {
                        handleSubmit()
                    }
                    else {
                        setAddProjectError('Please complete all the form fields');
                        return;
                    }
                }}>
                    Add
                </Button>
            </DialogActions>
        </Dialog>
    );
}